import React from "react";
import Slider from "react-slick";
// Import css files for carousel
// Getting these from CDN now but might want to change that
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

const PrevArrow = ({ className, style, onClick }) => {
    return (
        <div 
            className={`${className} si-carousel-arrow icon font prev`}
            style={{...style}}
            onClick={onClick}
            >
        </div>
    )
}
const NextArrow = ({ className, style, onClick }) => {
    return (
        <div 
            className={`${className} si-carousel-arrow icon font next`}
            style={{...style}}
            onClick={onClick}
            >
        </div>
    )
}

const Service = ({ service }) => {
    const { title, images, descriptions, galleryLink } = service;
    const sliderConfig = {
        dots: true,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        customPaging: i => <button className="si-carousel-prg-dot" title={`Go to picture number ${i + 1}`}></button>,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        lazyLoad: true,
    };

    return (
        <li className="rc-services-list-item">
            <p className="service-title">{title}</p>
            <div className="service-info">
                <div className="carousel-container">
                    <Slider className="si-carousel" {...sliderConfig}>
                        {
                            images.map((image, index) => {
                                const { url, alt, description} = image;
                                return (
                                    <div className="img-slide" key={index}>
                                        <img src={url} alt={alt}/>
                                        <p className="img-slide-description">{description}</p>
                                    </div>
                                )
                            })
                        }
                    </Slider>
                    <div className="diaganol"></div>
                </div>
                <div className="si-description">
                    <ul className="si-description-list">
                        {
                            descriptions.map((copy, index) => <li className="si-description-list-item" key={index}>{copy}</li>)
                        }
                    </ul>
                    <div className="si-gallery-link">
                        <a href={`/gallery${(galleryLink) ? `/${galleryLink}` : ""}`} className="link icon font">view this work</a>
                    </div>
                </div>
            </div>
        </li>
    )
}

export default Service;
